import Home from "./components/Home";
import Login from "./components/Login";
import Account from "./components/Account";
import Admin from "./components/Admin";
import EditCenter from "./components/ManagerPanels/EditCenter";
import MenuSetting from "./components/ManagerPanels/MenuSetting";
import KdcOpen from "./components/KdcOpen";
import Search from "./components/Search";
import News from "./components/News";
import QAEditor from "./components/ManagerPanels/QAEditor";
import EditorRules from "./components/ManagerPanels/EditCenterPanels/EditAreaPanels/EditorRules";
import Preview from "./components/Common/Preview";

const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path: "/Login",
    element: <Login />
  },
  {
    path: '/Login/:panel',
    element: <Login />
  },
  {
    path: '/MyPage/:account',
    element: <Account />
  },
  {
    path: '/MyPage',
    element: <Account />
  },
  {
    path: '/Manager',
    element: <Admin />
  },
  {
    path: '/Manager/:admin',
    element: <Admin />
  },
  {
    path: '/Manager/QAEditor/:id',
    element: <QAEditor />
  },
  {
    path: '/EditCenter',
    element: <EditCenter />
  },
  {
    path: '/EditCenter/News',
    element: <EditCenter />
  },
  {
    path: '/EditCenter/Rules/:type?',
    element: <EditorRules />
  },
  {
    path: '/EditCenter/Preview',
    element:<Preview />
  },
  {
    path: '/MenuSetting',
    element: <MenuSetting />
  },
  {
    path: '/KdcOpen',
    element: <KdcOpen />
  },
  {
    path: '/News',
    element:<News />
  },
  {
    path: '/Search',
    element:<Search />
  }
];

export default AppRoutes;
